import { AppMuiProviders, DatePickerProvider, homeTheme } from '@color/continuum';
import { AuthProvider, CookiesProvider, MultiTabDetectorProvider } from '@color/lib';
import { SnackbarProvider } from 'notistack';
import { HelmetProvider } from 'react-helmet-async';

import { AppIntlProvider } from './AppIntlProvider';
import { AppQueryClientProvider } from './AppQueryClientProvider';
import { LocaleConfigProvider } from './LocaleConfigProvider/context';
import { PatientMessagingProvider } from './PatientMessagingProvider';
import { WebVitalsProvider } from './WebVitalsProvider';

interface Props {
  children?: React.ReactNode;
}

export const AppProviders: React.FC<Props> = (props) => {
  return (
    <HelmetProvider>
      <AppQueryClientProvider>
        <CookiesProvider>
          <AuthProvider>
            <MultiTabDetectorProvider>
              <LocaleConfigProvider>
                <AppMuiProviders theme={homeTheme}>
                  <AppIntlProvider>
                    <WebVitalsProvider>
                      <DatePickerProvider>
                        <SnackbarProvider
                          anchorOrigin={{
                            horizontal: 'center',
                            vertical: 'top',
                          }}
                        >
                          <PatientMessagingProvider>{props.children}</PatientMessagingProvider>
                        </SnackbarProvider>
                      </DatePickerProvider>
                    </WebVitalsProvider>
                  </AppIntlProvider>
                </AppMuiProviders>
              </LocaleConfigProvider>
            </MultiTabDetectorProvider>
          </AuthProvider>
        </CookiesProvider>
      </AppQueryClientProvider>
    </HelmetProvider>
  );
};
